module.exports = __webpack_public_path__ + "img/icorp.d8161a61.svg";